/*
 * CELER · PDP Beta FURA — JS adicional sobre celer-pdp-v1.js
 *
 * Funciones:
 *   1) Countdown a fecha del evento. Se actualiza en tiempo real cuando
 *      faltan menos de 24h. Cuando faltan más de 21 días, solo muestra
 *      el texto sutil "Faltan X días" (no animación).
 *   2) FAQ accordion (vanilla, idéntico al patrón Celer pero scoped).
 *   3) Delivery accordion (V6 "Cómo recibes tu gorra").
 */

(function(){
  'use strict';

  function initFaq() {
    var items = document.querySelectorAll('.bfura-faq__item');
    items.forEach(function(item){
      var trigger = item.querySelector('.bfura-faq__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function(){
        var isOpen = item.classList.contains('bfura-faq__item--open');
        items.forEach(function(other){
          other.classList.remove('bfura-faq__item--open');
          var ot = other.querySelector('.bfura-faq__trigger');
          if (ot) ot.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('bfura-faq__item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initCountdown() {
    var el = document.querySelector('[data-bfura-countdown]');
    if (!el) return;
    var targetIso = el.getAttribute('data-target');
    if (!targetIso) return;

    var target;
    try {
      target = new Date(targetIso);
      if (isNaN(target.getTime())) return;
    } catch(e) { return; }

    function update() {
      var now = new Date();
      var diffMs = target.getTime() - now.getTime();
      var textEl = el.querySelector('[data-bfura-countdown-text]');
      if (!textEl) return;
      if (diffMs <= 0) {
        textEl.innerHTML = 'Entregas en curso';
        return;
      }
      var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      var diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      var diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);

      if (diffDays >= 7) {
        textEl.innerHTML = 'Faltan <strong>' + diffDays + ' días</strong>';
      } else if (diffDays >= 1) {
        textEl.innerHTML = 'Faltan <strong>' + diffDays + 'd ' + diffHours + 'h</strong>';
      } else if (diffHours >= 1) {
        textEl.innerHTML = 'Empieza en <strong>' + diffHours + 'h ' + diffMins + 'min</strong>';
      } else {
        textEl.innerHTML = 'Empieza en <strong>' + diffMins + 'min ' + diffSecs + 's</strong>';
      }
    }

    update();
    var diffMs = target.getTime() - new Date().getTime();
    var interval = diffMs > (1000 * 60 * 60 * 24) ? 60000 : 1000;
    setInterval(update, interval);
  }

  function initDeliveryAcc() {
    var accs = document.querySelectorAll('[data-bfura-delivery-acc]');
    accs.forEach(function(acc){
      var trigger = acc.querySelector('.bfura-delivery-acc__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function(){
        var isOpen = acc.classList.contains('bfura-delivery-acc--open');
        if (isOpen) {
          acc.classList.remove('bfura-delivery-acc--open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          acc.classList.add('bfura-delivery-acc--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    initFaq();
    initCountdown();
    initDeliveryAcc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
